<!-- src/components/Sites/ListTooltip.vue -->
<template>
  <div v-if="filteredList && filteredList.length > 0" class="bg-gray-800 text-white text-sm rounded shadow-lg p-2 z-50">
    <ul class="space-y-1">
      <li v-for="(item, index) in filteredList" :key="index">
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ListTooltip',
  props: ['params'],
  computed: {
    filteredList() {
      const list = this.params.value;

      if( !list ) return [];
      if( !Array.isArray(list) ) return [];

      return list.filter( item => item.length !== 0 ).sort();
    },
  },
};
</script>

